import { useSpeechStore } from '@/shared/store/speech.store.ts'
import type { Speech } from '@/features/speech/domain/models/speech.ts'
import type { Voice } from '@/features/voice/domain/models/voice.ts'

export const storeSpeech = (
  speech: Speech,
  scriptId: string,
  voice: Voice,
  speed: number,
  expressive = false
): void => {
  const { storeSpeech } = useSpeechStore.getState()
  storeSpeech(speech.speechId, {
    speechId: speech.speechId,
    previewUrl: speech.speechUrl,
    type: speech.type,
    scriptId,
    voice,
    expressive,
    speed,
    ...(speech.fileId ? { fileId: speech.fileId } : {}),
    ...(speech.anchor ? { anchor: speech.anchor } : {}),
  })
}
